<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-organisations')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.organisation') })"></i>
        <i v-if="this.$can('delete-organisations')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.organisation') })"></i>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        DestroyAlert,
        SuccessAlert,
        ErrorAlert,
    } from '~/Swals'

    export default {
        name: 'actions',
        props: ['data', 'index'],

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.organisation') }).show().then(async () => {
                    this.destroy()
                });
            },

            edit() {
                this.$router.push({ name: 'admin.organisations.edit', params: { id: this.data.id }})
            },

            async destroy() {
                window.axios.delete(route('organisations.destroy', {
                    organisation: this.data.id,
                })).then(response => {
                    if(response.data.id !== null) {
                        new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.organisation') })}).show();
                        vue.$emit('reloadTable');
                        return
                    }
                }).catch(error => {
                    console.log(JSON.parse(JSON.stringify(error)));
                    if (error.response && error.response.status === 422) {
                        new ErrorAlert({
                            title: this.uLang('app.entity_cant_be_deleted', { entity: this.lang('app.organisation') }),
                            text: error.response.data.message
                        }).show()
                        return
                    }
                    new ErrorAlert({
                        title: this.uLang('app.entity_cant_be_deleted', { entity: this.lang('app.organisation') }),
                        text: error.response.statusText
                    }).show()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
